import { create } from "zustand";

interface LayoutChromeStore {
  /** Hides both the header and the sidebar (used by PnL competitions). */
  hideChrome: boolean;
  setHideChrome: (hide: boolean) => void;
  /** Hides the global mobile bottom navigation (`Menu`). */
  hideMobileNav: boolean;
  setHideMobileNav: (hide: boolean) => void;
}

export const useLayoutChromeStore = create<LayoutChromeStore>((set) => ({
  hideChrome: false,
  setHideChrome: (hide) => set({ hideChrome: hide }),
  hideMobileNav: false,
  setHideMobileNav: (hide) => set({ hideMobileNav: hide }),
}));
